export enum EAction {
    serviceCancellation = "serviceCancellation",
    serviceValidation = "serviceValidation",
    serviceEdition = "serviceEdition",
    bookingCreation = "bookingCreation",
}
